import { regularizedPhone } from "@sourcewhale/shared/src/assets/js/src/general/utils";

// Augment the candidatePhoneStore with last messaged timestamps for each phone number
// (used in SendMessagePhoneList.svelte)
export const MessagePhoneStore = ($activityFeedStore, $candidatePhoneStore) => {
  const lastMessaged = {};

  // 262 - "SMS Sent", 264 - "WhatsApp Sent"
  const activityCodeMap = { 262: "sms", 264: "whatsapp" };

  // Don't do anything if we don't have an activity feed (e.g. search page)
  if (!$activityFeedStore || !$activityFeedStore.feed)
    return $candidatePhoneStore.map((phoneEntry) => ({
      ...phoneEntry,
      lastMessaged: {},
    }));

  // Filter relevant message activities
  const messageActivities = $activityFeedStore.feed.filter(
    (activity) =>
      activity.activityCode &&
      Object.keys(activityCodeMap).includes(activity.activityCode.toString()),
  );

  messageActivities.forEach((activity) => {
    const type = activityCodeMap[activity.activityCode];
    const phoneNumber = regularizedPhone(activity.to);

    // Initialize entry for this phone number if it doesn't exist
    if (!lastMessaged[phoneNumber]) {
      lastMessaged[phoneNumber] = { whatsapp: null, sms: null };
    }

    // Update the timestamp if newer
    const currentValue = lastMessaged[phoneNumber][type];
    if (currentValue === null || activity.timestamp > currentValue) {
      lastMessaged[phoneNumber][type] = activity.timestamp;
    }
  });

  // Map candidatePhoneStore to include last messaged timestamps
  return $candidatePhoneStore.map((phoneEntry) => ({
    ...phoneEntry,
    lastMessaged: lastMessaged[regularizedPhone(phoneEntry.phone)] || {},
  }));
};
